import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "finger", "fill", "transform", "stroke"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6050 8889 c-894 -63 -1719 -421 -2285 -994 -141 -142 -195 -213 -211 -276 -40 -154 82 -293 243 -276 73 8 106 31 202 142 294 341 776 643 1281 803 628 199 1383 213 2055 37 466 -122 874 -324 1278 -633 137 -105 180 -122 264 -104 120 25 197 133 179 253 -13 90 -57 133 -317 319 -751 538 -1710 798 -2689 729z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M6090 8109 c-925 -79 -1634 -447 -2223 -1153 -247 -296 -567 -753 -605 -865 -31 -89 7 -201 86 -256 40 -27 51 -30 126 -30 74 0 87 3 125 28 26 17 57 52 79 88 200 326 489 710 707 938 530 556 1254 833 2110 808 428 -13 795 -106 1182 -301 460 -231 905 -604 1221 -1023 72 -95 110 -127 172 -143 182 -49 340 146 255 316 -74 149 -493 598 -745 800 -545 435 -1093 683 -1718 775 -158 23 -594 34 -772 18z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M6180 7323 c-230 -16 -516 -80 -716 -158 -338 -133 -602 -312 -874 -591 -211 -217 -354 -406 -556 -734 -136 -223 -152 -245 -243 -360 -137 -174 -319 -339 -498 -453 -91 -59 -125 -107 -131 -187 -5 -70 10 -120 51 -166 59 -69 146 -94 231 -70 103 30 328 197 506 376 182 182 280 314 504 676 253 410 536 721 828 911 229 150 485 245 778 289 139 22 467 24 610 5 532 -71 956 -288 1302 -668 150 -164 298 -390 387 -589 165 -368 168 -550 26 -1449 -84 -531 -98 -710 -71 -895 50 -335 210 -623 540 -967 133 -138 187 -173 270 -173 122 1 226 104 226 225 0 74 -19 106 -139 230 -200 207 -288 324 -367 488 -114 238 -115 370 -9 1042 132 836 137 1129 26 1456 -127 376 -355 741 -641 1028 -433 432 -981 680 -1619 730 -125 10 -314 12 -421 4z" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("path", { d: "M6230 6540 c-533 -47 -1021 -334 -1384 -813 -126 -167 -185 -266 -322 -542 -133 -269 -188 -353 -350 -537 -189 -213 -512 -483 -846 -706 -135 -90 -178 -147 -178 -235 0 -88 77 -194 156 -216 100 -28 147 -12 330 114 421 287 782 609 1010 901 94 119 169 244 266 444 172 354 281 515 477 710 227 225 457 352 741 410 123 25 337 27 466 5 269 -47 528 -184 739 -390 157 -153 257 -307 314 -481 49 -152 56 -211 55 -444 -1 -242 -7 -289 -99 -770 -67 -349 -82 -450 -95 -633 -32 -448 122 -1000 369 -1329 166 -219 376 -369 669 -477 139 -52 231 -37 304 48 63 74 72 171 22 258 -32 55 -63 76 -193 127 -60 24 -138 59 -172 79 -258 145 -425 418 -516 842 -25 117 -27 150 -28 330 0 223 2 241 90 700 97 507 119 712 104 975 -29 509 -260 929 -696 1263 -347 266 -811 404 -1233 367z" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("path", { d: "M9141 5896 c-49 -18 -111 -74 -132 -120 -29 -65 -24 -122 20 -234 84 -209 142 -518 161 -852 22 -368 -21 -857 -111 -1284 -34 -161 -36 -215 -10 -271 77 -169 318 -177 402 -13 23 45 58 204 98 448 122 741 104 1406 -54 1950 -54 184 -99 283 -151 329 -64 56 -149 74 -223 47z" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", { d: "M6290 5729 c-336 -29 -647 -218 -845 -514 -29 -44 -107 -188 -173 -321 -237 -475 -388 -693 -681 -984 -238 -237 -410 -374 -1044 -830 -361 -259 -378 -274 -392 -362 -23 -136 83 -258 225 -258 34 0 69 7 90 18 41 21 566 394 795 565 535 401 821 683 1085 1073 119 176 209 335 345 609 83 168 129 248 170 298 138 167 319 257 515 257 306 0 538 -242 601 -628 43 -263 -126 -662 -476 -1121 -441 -578 -1232 -1315 -2109 -1965 -141 -105 -160 -122 -182 -169 -31 -67 -31 -127 0 -194 53 -113 197 -160 310 -101 41 22 374 275 601 457 1213 973 1994 1866 2229 2550 61 175 80 284 80 461 0 136 -3 168 -27 264 -75 301 -210 524 -413 686 -138 110 -341 194 -498 206 -39 3 -82 6 -96 8 -14 1 -63 -1 -110 -5z" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("path", { d: "M6292 4815 c-73 -32 -88 -52 -170 -217 -208 -417 -523 -834 -992 -1311 -410 -418 -794 -747 -1330 -1140 -107 -79 -205 -158 -217 -176 -49 -72 -48 -177 2 -253 48 -72 156 -112 242 -89 49 13 86 38 338 226 793 590 1464 1233 1920 1840 202 268 338 486 448 712 77 161 85 217 40 303 -39 74 -101 113 -187 117 -39 2 -73 -2 -94 -12z" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", { d: "M7011 3060 c-18 -4 -52 -21 -74 -36 -68 -48 -142 -208 -183 -397 -24 -110 -29 -342 -10 -459 40 -242 155 -496 321 -703 132 -166 416 -425 514 -468 103 -45 230 0 283 102 57 109 31 206 -82 299 -336 277 -490 477 -565 737 -53 184 -42 387 31 551 49 109 56 139 43 200 -25 124 -154 206 -278 174z" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("path", { d: "M5920 1819 c-185 -48 -389 -187 -630 -428 -167 -167 -210 -230 -210 -304 0 -90 47 -169 123 -209 54 -29 147 -30 197 -4 19 11 105 90 190 177 208 211 362 322 468 336 66 9 143 -20 206 -78 89 -81 158 -205 220 -396 32 -95 58 -139 105 -170 105 -71 250 -44 318 58 32 49 42 136 23 207 -22 80 -99 274 -137 342 -80 146 -182 271 -282 344 -172 126 -401 175 -591 125z" }, null, -1)
const _hoisted_11 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]

import { computed, PropType } from 'vue';
import { FINGERS, FingerStatus } from '../types/FingerStatus';
  
export default /*#__PURE__*/_defineComponent({
  ...{
      name:'Fingerprint',
  },
  __name: 'Fingerprint',
  props: {
      fingerId: {
        type: Number as PropType<FINGERS>,
        required: true,
      },
      fingerName: {
        type: String,
        required: false,
      },
      status: {
          type: FingerStatus,
          required: true,
      },
      transform: {
        type: String,
        default: '',
      },
      stroke: {
        type: String,
        default: 'none',
      },
      title: String,
  },
  setup(__props) {

const props = __props;


  
  const fingerName = computed(() => {
    return props.fingerName !== undefined ? props.fingerName : FingerStatus.fingerFromId(props.fingerId);
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", {
    id: fingerName.value,
    finger: __props.fingerId,
    class: "print",
    style: _normalizeStyle(__props.status.status),
    fill: __props.status.fill,
    transform: __props.transform,
    stroke: __props.stroke
  }, _hoisted_11, 12, _hoisted_1))
}
}

})